<template>
    <div class="echart-chart-block">
        <!-- {{ chartID }}<br> -->
        <!-- {{ $t('sensor.' + sensorCode) }} -->
        <div class="chart-info" :style="sensorStyle">
            <div class="chart-title">
                <i :class="$tools.style.classSensorIcon(sensorCode, 'block-title')"></i>{{ $t('sensor.' + sensorCode) }}
            </div>
            <div v-if="info_type == 'realtime'" class="latest-value">
                <div v-if="lastValue != undefined">
                    <div class="latest-value-number">{{ lastValue }}</div>
                    <div class="latest-value-unit" v-html="$t('sensor.u_' + sensorCode)"></div>
                    <div class="latest-value-number">{{ lastValueStandard }}</div>
                </div>
            </div>
        </div>
        <div :id="chartID" class="chart"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import echarts from 'echarts'
import ecTools from '@/echarts/echarts-tools'

export default {
    props:
    {
        chartID: {
            type: String,
            required: true,
        },
        info_type: {
            type: String,
            default: 'realtime',
        },
        sensorCode: {
            type: String,
            required: true,
        },
        data: {
            type: Array,
            default: function () { return [] }
        },
        time: {
            type: Array,
            default: function () { return [] }
        },
        standard: {
            type: Object,
            default: undefined,
        },
        compareList: {
            type: Array,
            default: function () { return [] }
        },
        deviceInfo: {
            type: Object,
            default: undefined,
        },
        showToolbox: {
            type: Boolean,
            default: true,
        },
        xAxisName: { type: String, },
        yAxisName: { type: String, },
        xAxisFormat: {
            type: String,
            default: 'MM/DD HH:mm',
        },
    },
    data () {
        return {
            theChart: undefined,
            lastValue: undefined,
            lastValueStandard: '',
        }
    },
    mounted () {
        this.theChart = echarts.init(document.getElementById( this.chartID ));
        this.drawChartPrepare();
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
            'screenWidth': state => state.system.screenWidth,
            'contentWidth': state => state.system.contentWidth,
        }),

        sensorStyle ()
        {
            let _setting = ecTools.getSensorSettings( this.sensorCode )
            
            return {
                color: ecTools.chart_HeatMap_Color[ _setting.color ][2]
            }
        },
    },
    watch: {
        // 偵測到 [ 語言 ] 變動就更新圖表
        language ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 時間 ] 變動就更新圖表
        time ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 標準 ] 變動就更新圖表
        standard ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 視窗寬度 ] 變動就更新圖表
        screenWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
        // 偵測到 [ 版面寬度 ] 變動就更新圖表
        contentWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
    },
    methods: {

        set_LastValueStandard_Line (_warning_line, _lastValue)
        {
            this.lastValueStandard = ecTools.getWarningLineText(_warning_line, _lastValue);
        },

        drawChartPrepare ()
        {
            // if (this.data && this.data.length > 0) {
                let _setting = ecTools.getSensorSettings( this.sensorCode )

                this.drawChart( this.theChart,
                                this.sensorCode,
                                this.data,
                                this.time,
                                this.standard,
                                _setting,
                                this.compareList,
                                this.deviceInfo,
                                this.showToolbox,
                                [ this.xAxisName, this.yAxisName ] );
            // }
        },
        
        drawChart ( chart,
                    _sensorCode,
                    _data,
                    _time,
                    _standard,
                    _sensorSetting,
                    _compareList,
                    _deviceInfo = undefined,
                    _showToolbox,
                    _axisName )
        {
            let _deviceName = '';
            let _unit = this.$t('sensor.u_' + _sensorCode);
            let _dataTitle = this.$t('sensor.' + _sensorCode);
            let _legendTitle = [];
            let _color = ecTools.getColorList( _sensorSetting.color );
            let _colorRGBA = ecTools.getColor_RGB( _color[1] );
            let _precision = _sensorSetting.precision;

            let _data_Line = [];
            let bounding = ( _sensorSetting.bounding != undefined ? _sensorSetting.bounding.slice() : [ 99999, -99999 ] );
            let bounding_limit = ( _sensorSetting.bounding_limit != undefined ? _sensorSetting.bounding_limit : [ undefined, undefined ] );

            if (_deviceInfo && _deviceInfo.name) _deviceName = _deviceInfo.nickname;

            _data_Line = _data;
            for (let i=0; i<_data_Line.length; i++)
            {
                _data_Line[i] = ecTools.checkDataBounding(_data_Line[i], bounding, bounding_limit, _precision);
            }
            let days = ecTools.get_XAxis_day(_data_Line.length, _time, this.xAxisFormat);
            this.lastValue = _data_Line[ _data_Line.length-1 ];
            
            // 檢查視窗大小，顯示/隱藏項目
            let _chartWidth = chart.getWidth();

            _legendTitle.push( _deviceName + ' ' + _dataTitle );
            let _series =
            [
                {
                    name: _legendTitle[0],
                    type: 'bar',
                    showSymbol: false,
                    barMaxWidth: 18,
                    data: _data_Line,
                    label: {
                        show: true,
                        position: 'top',
                        distance: 2,
                        formatter: function (params) {
                            //console.log(params.value);
                            
                            // 圖表寬度太小就不顯示 Bar 上文字
                            if (_chartWidth < 600) return '';

                            let _showText = params.value;

                            if (_standard != undefined && _standard.warning_line != undefined)
                            {
                                if ( parseFloat( params.value ) > 0.0 )
                                {
                                    _showText = ecTools.getWarningLineText( _standard.warning_line, params.value );
                                    _showText += '\n' + params.value;
                                }
                                else _showText = '';
                            }

                            return _showText;
                        }
                    },
                    // markPoint: {
                    //     data: [
                    //         { type: 'max', name: 'max' },
                    //         { type: 'min', name: 'min' }
                    //     ]
                    // },
                    markLine: { silent: true, data: [] },
                    markArea: { silent: true, data: [] },
                    itemStyle: { color: _color[1] },
                    emphasis: {
                        itemStyle: {
                            color: '#ff8080',//_color[0],
                        },
                    },
                    animationDelay: function (idx) { return idx * 10; },
                    
                },
            ];
            

            if (_compareList != undefined)
            {
                for (let idx=0; idx<_compareList.length; idx++)
                {
                    let compare = _compareList[idx];
                    let _compareColor = ecTools.chart_HeatMap_Color['compare'][idx];
                    let _compareTitle = compare.name + ' ' + _dataTitle;

                    if (compare.data != undefined)
                    {
                        ecTools.checkDataListBounding (compare.data, bounding, bounding_limit, _precision);
                        _series.push( ecTools.create_DayLine( _legendTitle, _compareTitle, _compareColor[1], compare.data, false, false, _chartWidth ) );
                    }
                }
            }

            // 歷史線 or 歷史區域
            let _history = ecTools.checkMarkData( _deviceInfo, 'history', _sensorCode, undefined, bounding );
            if ( _history != undefined)
            {
                if (_history.warning_line != undefined)
                {
                    ecTools.createMarkLine( _history.warning_line, _series[0].markLine.data, bounding, '#339966' );
                }
                if (_history.warning_area != undefined)
                {
                    ecTools.createMarkArea( _history.warning_area, _series[0].markArea.data, bounding, _data.length );
                }
            }

            // 標準/警示線 or 標準/警示區域
            if (_standard != undefined)
            {
                if (_standard.warning_line != undefined)
                {
                    ecTools.createMarkLine( _standard.warning_line, _series[0].markLine.data, bounding );
                    this.set_LastValueStandard_Line( _standard.warning_line, _data_Line[ _data_Line.length-1 ] );
                }
                if (_standard.warning_area != undefined)
                {
                    ecTools.createMarkArea( _standard.warning_area, _series[0].markArea.data, bounding, _data.length );
                }
            }

            let _xAxisName = ( _axisName[0] ? this.$t('u.'+_axisName[0]) : '');
            let _yAxisName = ( _axisName[1] ? this.$t('u.'+_axisName[1]) : _unit );
            let option = {
                legend:
                {
                    y: '2%',
                    //right: 120,
                    data: _legendTitle
                },
                toolbox: ecTools.createToolbox( this.chartID, _deviceName + ' ' + _dataTitle + ' - Bar Chart', _showToolbox ),
                tooltip:
                {
                    trigger: 'axis',//'item',
                    formatter: function (params) {
                        //console.log(params);
                        let _u = _yAxisName;
                        let _tooltip = params[0].name;

                        params.forEach(function (p) {
                            _tooltip += '<br><i class="fa fa-circle" style="color:'+ p.color +';"></i> ' + p.seriesName + ': ' + p.value + ' ' + _u;
                            if (_standard && _standard.warning_line) _tooltip += ' ' + ecTools.getWarningLineText(_standard.warning_line, p.value);
                        });
                        
                        return _tooltip;
                    }
                },
                grid:
                {
                    x: ecTools.getGrid_x( bounding[1], _precision, _chartWidth ),//'5%',
                    //y: -30,
                    top: '22%',
                    bottom: '18%',
                    width: ecTools.getGrid_width( bounding[1], _precision, _chartWidth ),
                },
                visualMap:
                {
                    show: false,
                    type: 'continuous',
                    seriesIndex: 0,
                    min: ( bounding[0] - 2 ),
                    max: bounding[1],
                    inRange:    { color: _color },
                    outOfRange: { color: '#eee' },
                },
                xAxis:
                {
                    type: 'category',
                    name: _xAxisName,
                    nameGap: 25,
                    nameLocation: 'center',
                    data: days,
                    boundaryGap: true,
                    splitArea: { show: false },
                    splitLine: { show: false },
                },
                yAxis:
                {
                    name: ecTools.show_chart_unit( _yAxisName ),
                    nameGap: 10,
                    min: ( bounding[0] ),
                    max: ( bounding[1] ),
                    splitArea: { show: false },
                    splitLine: {
                        show: ( _series[0].markLine.data.length > 0 ? false : true ),
                        lineStyle: {
                            color: 'rgba(' + _colorRGBA[0] + ',' + _colorRGBA[1] + ',' + _colorRGBA[2] + ',0.25)',
                        }
                    },
                },
                series: _series,
                animation: true,
            };
            chart.setOption(option);
        },

    }
    
}
</script>

<style lang="scss" scoped>

</style>
